import NavigationScroll from "../components/navigation";
import React from "react";

function ServicesPage() {
    return (
        <>
            <NavigationScroll/>
            <div className="page">

                <div className="container-center">
                    <div className="top-section">
                        <h1>Our Services</h1>
                    </div>
                    <div className="middle-section">
                        <h2><a href="/services">Cybersecurity</a></h2>
                        <h2><a href="/services">Risk Mitigation</a></h2>
                            <h2><a href="/services">IT Strategy Development</a></h2>
                    </div>

                    <div className="bottom-section">

                        <h3>Whatever your need, we can solve IT.</h3>

                        <h5>Book a consultation through</h5>
                        <h5><a href="mailto:info@iextrem.com">info@iextrem.com</a></h5>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ServicesPage;
